<template lang="html">
  <div id="TOC">
    <div class="page-header"
      :style="{ background: 'no-repeat url(' + bookBanner + ')' }">
      <div class="page-header-content page-container">
        {{this.bookTitle}}
      </div>
    </div>
    <div class="body">
      <div class="page-container">
        <div class="body-title">
          Table of contents
        </div>
        <div class="body-content">
          <v-expansion-panels accordion>
            <v-expansion-panel
             @click="triggerGAChapterSelected(content.ChapterName[0])"
             v-for="(content, index) in contents"
             :key=index >
              <v-expansion-panel-header>
                <span class="panel-title" >{{ content.ChapterName[0] }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content >
                <div class="option-grid">
                  <template v-for="(subItem, index) in content.Section">
                    <TOCItem
                    :section-title="subItem.SectionName[0]"
                    :section-data="subItem"
                    :chapter-name="content.ChapterName[0]"
                    :bookTitle="bookTitle"
                    :key=index />
                  </template>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { mapState, mapMutations, mapActions } from 'vuex'
import TOCItem from '@/components/toc/TOCItem'
import ContentIcon from '../../public/img/icons/content_icon.png'
import ExercisesIcon from '../../public/img/icons/exercises_icon.png'
import StudyCardsIcon from '../../public/img/icons/study_cards_icon.png'
import VideosIcon from '../../public/img/icons/videos_icon.png'

export default {
  name: 'TOC',
  props: ['book'],
  components: {
    TOCItem
  },
  beforeMount () {
    this.setBookFilename(this.book)
    this.setChapterHeading('')
  },
  mounted () {
    this.getChapterMap()
  },
  data () {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      ContentIcon,
      ExercisesIcon,
      StudyCardsIcon,
      VideosIcon
    }
  },
  methods: {
    ...mapMutations({
      setBookFilename: 'book/SET_BOOK_FILENAME',
      setChapterTitle: 'book/SET_CHAPTER_TITLE',
      setChapterHeading: 'book/SET_CHAPTER_HEADING'
    }),
    ...mapActions({
      getChapterMap: 'book/GET_CHAPTER_MAP',
      incrementComponentKey: 'book/INCREMENT_COMPONENT_KEY'
    }),
    dialogClose: close => {
      this.dialog = false
    },
    triggerGAChapterSelected (chapterSelected) {
      this.$gtm.trackEvent({
        event: 'user_clicked_chapter',
        category: 'TOC',
        action: 'click',
        label: 'User clicked a chapter panel',
        productName: this.bookTitle,
        chapterName: chapterSelected
      })
    }
  },
  computed: {
    ...mapState({
      bookTitle: state => state.book.bookTitle,
      chapterMap: state => state.book.chapterMap,
      chapterTitle: state => state.book.chapterTitle,
      contents: state => state.book.contents,
      bookBanner: state => state.book.bookBanner
    })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/variables.scss";
#TOC {
  .page-header {
    .page-header-content {
      padding: 25px;
      font-size: $PageTitle;
      color: #fff;
      @media screen and (min-width: 750px) {
        padding: 25px 180px;
      }
    }
    @media screen and (max-width: 600px) {
     background-position: center !important;
    }
  }
  .body {
    margin-bottom: 25px;
    .body-title {
      margin-top: 16px;
      font-size: $SectionTitle;
    }
    .body-content {
      margin-top: 32px;
      .v-expansion-panels {
        z-index: unset;
        position: inherit;
        .v-expansion-panel {
          position: inherit;
          margin-bottom: 16px;
          border: 1px solid #f2f2f2;
          box-sizing: border-box;
          box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.05);
          &:last-child {
            margin-bottom: 0px;
          }
          .v-expansion-panel-header {
            position: inherit;
            font-size: $SectionTitle;
            padding: 24px 25px;
            display: flex;
            flex-direction: row-reverse;
            color: $black;
            line-height: 15px;
            letter-spacing: 0.64px;
            color: black;
            .panel-title {
              flex: inherit;
              margin-right: auto;
            }
            .v-expansion-panel-header__icon {
              margin-left: 0px;
              .v-icon {
                margin-right: 25px;
                font-size: 30px;
                color: $black;
              }
            }
          }

          .v-expansion-panel-content {
            .v-expansion-panel-content__wrap {
              padding: 0px 80px 16px;
              .option-grid {
                display: grid;
                grid-template-columns: repeat(3, 300px);
                justify-content: space-between;
                grid-gap: 32px;
              }
            }
          }
        }
      }
    }
  }

  .page-container {
    max-width: 1600px;
    margin: auto;
    padding: 0px 25px;
    @media screen and (min-width: 750px) {
      padding: 0px 180px;
    }
  }
}

@media (max-width: 900px) {
  #TOC {
    .body {
      .body-content {
        .v-expansion-panels {
          .v-expansion-panel {
            .v-expansion-panel-content {
              .v-expansion-panel-content__wrap {
                padding: 0px 25px 25px;
                .option-grid {
                  grid-template-columns: repeat(1, 100%);
                  grid-gap: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 901px) and (max-width: 1360px) {
  #TOC {
    .body {
      .body-content {
        .v-expansion-panels {
          .v-expansion-panel {
            .v-expansion-panel-content {
              .v-expansion-panel-content__wrap {
                padding: 0px 25px 25px;
                .option-grid {
                  grid-template-columns: repeat(2, 45%);
                  justify-content: space-around;
                  grid-gap: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 1360px) and (max-width: 1500px) {
  #TOC {
    .body {
      .body-content {
        .v-expansion-panels {
          .v-expansion-panel {
            .v-expansion-panel-content {
              .v-expansion-panel-content__wrap {
                padding: 0px 25px 25px;
                .option-grid {
                  grid-template-columns: repeat(3, 30%);
                  justify-content: space-around;
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>
